import React, {useState, useRef} from 'react';
import { SearchInput, Icon } from '@amzn/storm-ui';
import styled from 'styled-components';
import { useAccountContext } from './AccountContextProvider';
import { AccountInfoByType } from './Types';
import { spinner } from '@amzn/storm-ui-icons';
import { useBundle } from '@amzn/react-arb-tools';
import { AccountSelectorMetricsPublisher } from '../metrics';

const SearchInputContainer = styled.div`
  & div {
    max-width: 700px;
  }
`;

export const AccountListSearch: React.VFC = () =>{
  const [searchValue, setSearchValue] = useState('');
  const searchInputRef = useRef<HTMLInputElement>();
  const {setFilteredAccounts, accounts} = useAccountContext();

  const onSearch = (target) => {
    const searchValue = target.value;
    const regex = new RegExp(searchValue, 'i');
    const filteredAccountsToSet = accounts.map((account: AccountInfoByType) => {
      return {
        label: account.label,
        accountType: account.accountType,
        accounts: account.accounts.filter((account) => regex.test(account.label))
      }
    });
    setFilteredAccounts(filteredAccountsToSet);
    AccountSelectorMetricsPublisher.publishCounterMonitor('search', 1);
  }

  const setSearchInputRef = element => {
    searchInputRef.current = element;
  };

  const handleChange = ({ target }) => {
    setSearchValue(target.value || '');
    searchInputRef.current?.focus();
    onSearch(target);
  };

  const [bundle, isBundleLoading] = useBundle('pages.interstitial');

  if (isBundleLoading) {
    return <Icon type={spinner}></Icon>
  }

  const searchAccountsLabel = bundle.getMessage('search_accounts');

  return (
    <SearchInputContainer>
      <SearchInput
        id="account-search"
        placeholder={searchAccountsLabel}
        inputRef={setSearchInputRef}
        value={searchValue}
        onChange={handleChange}
        onClear={handleChange}
        data-takt-id="interstitial-search-account"
      />
    </SearchInputContainer>
  );
}